module.exports = __webpack_public_path__ + "static/media/photo264.f7d96948.jpg";